import { Validation } from "./Validation";

/**
 * Programmbaustein für ein Gruppenevent.
 */
export default interface GroupBookingProgramJson {
   ID: number | null;

   /**
    * Titel der ausgewählten Programmbausteine.
    */
   title: string;

   /**
    * Detaillierte Beschreibung der ausgewählten Programmbausteine.
    */
   description: string;

   /**
    * Basispreis zu dem dieses Programm für einen halben Tag angeboten wird in Eurocent. Gilt maximal für eine bestimme Teilnehmerzahl.
    */
   basePriceHalfDay: number;

   /**
    * Basispreis zu dem dieses Programm für einen ganzen Tag angeboten wird in Eurocent. Gilt maximal für eine bestimme Teilnehmerzahl.
    */
   basePriceFullDay: number;

   /**
    * Teilnehmerzahl bis zu der der Basispreis gilt.
    */
   basePriceParticipantCount: number;

   /**
    * Kosten für pro Teilnehmer für jeden Teilnehmer über der Teilnehmerzahl für den Basispreis.
    */
   extraParticipantPrice: number;

   /**
    * Kosten die bei einer Stornierung anfallen in Eurocent.
    */
   cancellationFee: number;

   /**
    * Stornierungsbedingungen.
    */
   cancellationRemarks: string;

}

export function validateGroupBookingProgramJsonManagement(item: GroupBookingProgramJson) {
   return new Validation(item)
      .validateInteger("ID", 0)
      .validateNonEmptyString("title", 200)
      .validateString("description", null)
      .validateInteger("basePriceHalfDay", 0, null)
      .validateInteger("basePriceFullDay", 0, null)
      .validateInteger("basePriceParticipantCount", 0, null)
      .validateInteger("extraParticipantPrice", 0, null)
      .validateInteger("cancellationFee", 0, null)
      .validateString("cancellationRemarks", 500)
      .finish();
}

export function validateGroupBookingProgramJsonManagementAdd(item: GroupBookingProgramJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateNonEmptyString("title", 200)
      .validateString("description", null)
      .validateInteger("basePriceHalfDay", 0, null)
      .validateInteger("basePriceFullDay", 0, null)
      .validateInteger("basePriceParticipantCount", 0, null)
      .validateInteger("extraParticipantPrice", 0, null)
      .validateInteger("cancellationFee", 0, null)
      .validateString("cancellationRemarks", 500)
      .finish();
}